module.exports = __webpack_public_path__ + "img/roll-bg.677c3485.jpg";